import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateStatementPdfSideEffectContext = BaseLoanIdSideEffect.extend({
  paymentDueId: PaymentDueId,
  disableMailTask: z.boolean().optional(),
});
export const GenerateStatementPdfSideEffect = GenerateStatementPdfSideEffectContext.extend({
  type: z.literal('generateStatementPDF'),
});
export type GenerateStatementPdfSideEffect = z.infer<typeof GenerateStatementPdfSideEffect>;
